export const APP_CONTAINER_CLASSNAME = "cabinet-app-container";

export const APP_ROOT_CLASSNAME = "cabinet-app-root";

export const POPUP_CLASSNAME = "cabinet-app-modal";

/**
 * Pages of the host site that renders this bundle. They are site-relative on
 * purpose: the cabinet only ever runs on that site, local stack included.
 */
export const SIGN_IN_URL = "/auth/sign-in";
export const QUOTE_URL = "/request-it-quote";
export const PRODUCTS_URL = "/products";
export const HELP_URL = "/help";
export const TRACKING_URL = "/tracking/container";
export const AIR_TRACKING_URL = "/tracking/air";

/** External, so these stay absolute. */
export const DOCS_URL = "https://docs.qubictron.com/";
